/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//

import type { RasterResult, RasterizeOptions, SeparationOptions, SeparationResult } from "../types/Types"
import type { Float, Result } from "@pdfking/tfunc"
import { UInt8ToString } from "@pdfking/tfunc"
import type { RuntimeBridge } from "@pdfking/library-core"
const enum F {
    create_separation = "$4",
    rasterize_page = "$d"
}
export const NativeSymbols: Record<string, "std" | "next"> = { "$4": "std", "$d": "std" }
const f64_b = (v: number) => { const b = new Uint8Array(8); new DataView(b.buffer).setFloat64(0, v, true); return b; }
const u64_b = (v: bigint) => { const b = new Uint8Array(8); new DataView(b.buffer).setBigUint64(0, v, true); return b; }
type type_ChannelInclination = {
    black: type_Degree
    cyan: type_Degree
    magenta: type_Degree
    yellow: type_Degree
}
type type_ColorChannel = "cyan" | "magenta" | "yellow" | "black"
type type_Degree = Float<"Degree">
type type_Pixel = Float<"Pixel">
type type_PageNumber = Float<"PageNumber", "i64">
type Cursor = {
    i8(): bigint
    u8(): bigint
    i16(): bigint
    u16(): bigint
    i32(): bigint
    u32(): number
    f32(): number
    f64(): number
    i64(): bigint
    u64(): bigint
    i128(): bigint
    u128(): bigint
    i256(): bigint
    u256(): bigint
    ptr(): number
    bool(): boolean
    str(): string
    bytes(): Uint8Array
}
function* enc_ChannelInclination(v: type_ChannelInclination): Generator<Uint8Array> {
    yield f64_b(v.black)
    yield f64_b(v.cyan)
    yield f64_b(v.magenta)
    yield f64_b(v.yellow)
}
const dec_ixo9bgh4dhwt = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        channels: Array.from({ length: c.u32() }, () => ({
            bytes: c.bytes(),
            channel: variant_m.get(c.u64())!(c) as type_ColorChannel,
        })),
        height: c.f64() as type_Pixel,
        page: Number(c.i64()) as type_PageNumber,
        width: c.f64() as type_Pixel,
    }, error: undefined }
const dec_23ghdb301sapo = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        bytes: c.bytes(),
        height: c.f64() as type_Pixel,
        page: Number(c.i64()) as type_PageNumber,
        width: c.f64() as type_Pixel,
    }, error: undefined }
const variant_m = new Map<bigint, (c: Cursor) => unknown>([
    [15492634780859405855n, () => "cyan"],
    [15869110479400539346n, () => "magenta"],
    [1635004868251356540n, () => "yellow"],
    [5279583264840665123n, () => "black"],
])
export const CreateFunctions = <T extends number | bigint>(i: RuntimeBridge<T>) => {
    const pa = (v: number): T => i.conv(v)
    const ptr_b = (v: T): Uint8Array => i.memory64 ? u64_b(BigInt(v)) : new Uint8Array(new Uint32Array([Number(v)]).buffer)
    const write_args = (...chunks: Uint8Array[]): [
        number,
        number
    ] => {
        const total = chunks.reduce((s, c) => s + c.length, 0)
        const base = i.alloc(total)
        let off = 0
        for (const c of chunks) {
            i.write(base + off, c)
            off += c.length
        }
        return [base, total]
    }
    const write_buf = (data: Uint8Array): [
        number,
        number
    ] => {
        const ptr = i.alloc(data.length)
        i.write(ptr, data)
        return [ptr, data.length]
    }
    const call_with = (fn: string, ...chunks: Uint8Array[]): [
        number,
        number
    ] => {
        const [base, total] = write_args(...chunks)
        const ret = i.call(fn, pa(base), pa(total))
        i.free(base, total)
        return i.unpackReturn(ret)
    }
    const Cursor = (p: number, size: number): Cursor => {
        const raw = i.read(p, size)
        const dv = new DataView(raw.buffer, raw.byteOffset, raw.byteLength)
        let pos = 0
        const i8 = () => { const v = dv.getInt8(pos); pos += 1; return BigInt(v); }
        const u8r = () => { const v = dv.getUint8(pos); pos += 1; return BigInt(v); }
        const i16 = () => { const v = dv.getInt16(pos, true); pos += 2; return BigInt(v); }
        const u16 = () => { const v = dv.getUint16(pos, true); pos += 2; return BigInt(v); }
        const i32 = () => { const v = dv.getInt32(pos, true); pos += 4; return BigInt(v); }
        const u32 = () => { const v = dv.getUint32(pos, true); pos += 4; return v; }
        const f32 = () => { const v = dv.getFloat32(pos, true); pos += 4; return v; }
        const f64 = () => { const v = dv.getFloat64(pos, true); pos += 8; return v; }
        const i64 = () => { const v = dv.getBigInt64(pos, true); pos += 8; return v; }
        const u64 = () => { const v = dv.getBigUint64(pos, true); pos += 8; return v; }
        const i128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigInt64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
        const u128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigUint64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
        const i256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
            v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
        } pos += 32; return v >= (1n << 255n) ? v - (1n << 256n) : v; }
        const u256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
            v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
        } pos += 32; return v; }
        const ptr = () => { if (i.memory64) {
            const v = Number(dv.getBigUint64(pos, true))
            pos += 8
            return v
        } return u32(); }
        const bool = () => !!u32()
        const str = () => {
            const p = ptr()
            const len = ptr()
            const s = UInt8ToString(i.read(p, len))
            i.free(p, len)
            return s
        }
        const bytes = () => {
            const p = ptr()
            const len = ptr()
            const d = new Uint8Array(i.read(p, len))
            i.free(p, len)
            return d
        }
        return { i8, u8: u8r, i16, u16, i32, u32, f32, f64, i64, u64, i128, u128, i256, u256, ptr, bool, str, bytes }
    }
    function* enc_SeparationOptions(v: {
        angle: type_ChannelInclination
        data: Uint8Array
        dpi: type_Pixel
        icc: Uint8Array
        lpi: type_Pixel
    }): Generator<Uint8Array> {
        yield* enc_ChannelInclination(v.angle)
        yield* enc_1drvt9yiommpp(v.data)
        yield f64_b(v.dpi)
        yield* enc_1drvt9yiommpp(v.icc)
        yield f64_b(v.lpi)
    }
    function* enc_1drvt9yiommpp(v: Uint8Array): Generator<Uint8Array> {
        const [ptr, len] = write_buf(v)
        yield ptr_b(pa(ptr))
        yield ptr_b(pa(len))
    }
    function* enc_RasterizeOptions(v: {
        data: Uint8Array
        dpi: type_Pixel
        icc: Uint8Array
    }): Generator<Uint8Array> {
        yield* enc_1drvt9yiommpp(v.data)
        yield f64_b(v.dpi)
        yield* enc_1drvt9yiommpp(v.icc)
    }
    return {
        create_separation: (options: SeparationOptions): Result<SeparationResult> => {
            const [retPtr, retLen] = call_with(F.create_separation, ...enc_SeparationOptions(options))
            const result = dec_ixo9bgh4dhwt(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        rasterize_page: (options: RasterizeOptions): Result<RasterResult> => {
            const [retPtr, retLen] = call_with(F.rasterize_page, ...enc_RasterizeOptions(options))
            const result = dec_23ghdb301sapo(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
    }
}

